// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1yu_X","header":"PatientBlock_header__2Qc7x","label":"PatientBlock_label__9KpV4","option":"PatientBlock_option__3Sa5m"};